export class BookingViewModel
{
    rego?: string;
    nickname?: string;
}